import dotProp from 'dot-prop-immutable'
import { FRAMES_ARE_LOADING, FRAMES_FAILED, FRAMES_LOADED, CURRENT_FRAME_SIZE } from '../constants/framesActions'

export const loadFrames = getFrames => (dispatch, ownState) => {
  if (0 !== dotProp.get(ownState(), 'frames.frames', []).length) {
    return
  }

  dispatch({ type: FRAMES_ARE_LOADING })
  getFrames()
    .then(res => dispatch({ type: FRAMES_LOADED, frames: res }))
    .catch(err => dispatch({ type: FRAMES_FAILED, message: err.message }))
}

export const currentSize = ({ width, height }) => ({
  type: CURRENT_FRAME_SIZE,
  size: { width, height },
})



// WEBPACK FOOTER //
// ./src/actions/frames.js